// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2OqQK","footer":"Form_footer__1k9KD"};